/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Search
 */
export interface Search {
}

/**
 * Check if a given object implements the Search interface.
 */
export function instanceOfSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SearchFromJSON(json: any): Search {
    return SearchFromJSONTyped(json, false);
}

export function SearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): Search {
    return json;
}

export function SearchToJSON(value?: Search | null): any {
    return value;
}

